import { ConfigService, SystemUrlService } from "@xo/client-common";

export class Type9SpecialsUrlService extends SystemUrlService {
    constructor(system: string, configService: ConfigService) {
        super(system, "SpecApp", "Type9Specials", configService);
    }
}
